import { defineStore } from "pinia";

export const useMessengerStore = defineStore("messenger", {
  state: () => ({
    show: false,
    unreadMessages: false,
    passiveNotification: false,
  }),
  getters: {
    // Show the new-message bage if there are any unread messages or passive notifications (eg. new news)
    showBadge(state) {
      return state.unreadMessages || state.passiveNotification;
    },
  },
  actions: {
    setUnreadMessages(anyMessages: boolean) {
      this.unreadMessages = anyMessages;
    },
    setPassiveNotification(anyNotifications: boolean) {
      this.passiveNotification = anyNotifications;
    },
  },
});
